/* eslint-disable camelcase */
import { CompositeScreenProps } from "@react-navigation/native"
import { observer } from "mobx-react-lite"
import moment from "moment"
import numeral from "numeral"
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react"
import {
  Alert,
  Appearance,
  FlatList,
  ImageStyle,
  Linking,
  Platform,
  ScrollView,
  TextStyle, TouchableOpacity,
  View,
  ViewStyle,
} from "react-native"
import { AutoImage, Button, JalaIcon, Screen, Text, DeleteModal } from "../../../../components"
import { translate } from "../../../../i18n"
import { useStores } from "../../../../models"
import { color, nativeBaseTheme } from "../../../../theme"
import config from "../../../../utils/config"
import Share from "../../../../components/share/share"
import { navigate } from "../../../../navigators"
import { ShrimpPrice } from "../../../../database"
import { delay } from "../../../../utils/delay"
import _ from "lodash"
import SyncableModel from "../../../../database/SyncableModel"
import JalaAnalytic from "../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flexGrow: 1,
}

const TOP_BAR_CONTAINER: ViewStyle = {
  justifyContent: "center",
}

const SHARE_BUTTON: ViewStyle = {
  paddingHorizontal: 16,
  paddingLeft: 0
}

const LINE: ViewStyle = {
  height: 4,
  backgroundColor: color.palette.gray200
}

const SUB_HEADER: ViewStyle = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingHorizontal: 16,
  paddingVertical: 12,
  alignItems: 'center'
}

const SUB_LEFT: ViewStyle = {
  flexDirection: 'row'
}

const PADDING: ViewStyle = {
  paddingHorizontal: 16
}

const VERFIED_WRAPPER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: 67,
  marginTop: 12
}

const VERIF_TEXT: TextStyle = {
  marginLeft: 5,
  textTransform: 'capitalize'
}


const VERIF_WRAPPER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const IMG_VERIF: ImageStyle = {
  width: 18,
  height: 18,
  borderRadius: 18 / 2,
  backgroundColor: color.primary
}

const PROFILE_WRAPPER: ViewStyle = {
  flexDirection: 'row',
  marginTop: 8,
  borderBottomWidth: 1,
  paddingBottom: 20,
  borderColor: color.palette.gray200,
  ...PADDING
}

const IMG_PROFILE: ImageStyle = {
  backgroundColor: color.primary,
  width: 32,
  height: 32,
  borderRadius: 32 / 2
}

const DETAIL_WRAPPER: ViewStyle = {
  flex: 1,
  marginLeft: 20
}

const CONTACT_WRAPP: ViewStyle = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}

const CONTACT_BUTTON: ViewStyle = {
  paddingHorizontal: 16
}

const PRICE_WRAPPER: ViewStyle ={
  ...CONTACT_WRAPP,
  paddingVertical: 6,
  paddingHorizontal: 40,
  borderBottomWidth: 1,
  borderColor: color.palette.gray200
}

const NOTE_WRAPPER: ViewStyle = {
  ...PADDING,
  paddingTop: 16,
  paddingBottom: 8
}

const BTN_EDIT: ViewStyle = {
  marginLeft: 22,
}

const IMG_PARTNER: ImageStyle = {
  width: 16,
  height: 16,
  borderRadius: 16 /2
}

const LIST: ViewStyle = {
  paddingTop: 16,
  paddingBottom: 12,
  ...CONTACT_WRAPP,
  ...PADDING
}

const HEADER_LIST: ViewStyle = {
  borderTopWidth: 1,
  borderBottomWidth: 1,
  borderColor: color.palette.gray200,
  backgroundColor: color.palette.gray100,
  paddingVertical: 8,
  paddingHorizontal: 40,
  flexDirection: 'row',
  justifyContent: 'space-between'
}

const CARD_WRAPPER: ViewStyle = {
  width: 222,
  borderWidth: 1,
  borderColor: color.palette.gray200,
  borderRadius: 8,
  paddingHorizontal: 8,
  paddingTop: 8,
  paddingBottom: 33,
  marginBottom: 51
}

const TEXT_REGION: TextStyle = {
  width: '100%',
  textTransform: "capitalize",
  paddingBottom: 8,
  marginBottom: 8,
  borderBottomWidth: 1,
  borderColor: color.palette.gray200,
}

const PRICE_DIFF_WRAP: ViewStyle = {
  ...VERIF_WRAPPER,
  marginTop: 10
}

const PRICE_DIFF = (minus: boolean): ViewStyle => ({
  ...VERIF_WRAPPER,
  justifyContent: 'center',
  borderRadius: 30,
  backgroundColor: minus ? color.palette.red300 : color.palette.green300,
  paddingHorizontal: 8
})

const WIDTH: ViewStyle = {
  width: 16
}

const { BASE_URL } = config();

export const ShrimpPriceDetailShare: FC = observer(function ShrimpPriceDetailShare(props) {
  const { shrimpPriceStore: { shrimpPrice } } = useStores()

  const onShare = useCallback(async () => {
    const data = shrimpPrice;
    const { region } = data;
    const regionName = region ? region.name : '-';
    const date = data.date ? moment(data.date) : '-';
    const title = translate('sharePriceTitle', { date: moment(date).format('DD MMM YYYY'), region: regionName });
    const message = translate('checkLink', { url: `${BASE_URL}/shrimp_prices/${data.id}` });
    try {
      await Share.open({ message: `${title} ${message}`, failOnCancel: false })
      // JalaAnalytic.log(mixpanelKey);
    } catch (error) {
      Alert.alert(translate('failed'), translate('failedShared'), [{ text: 'OK' }]);
    }
  }, [shrimpPrice])

  return (
    <View style={TOP_BAR_CONTAINER}>
      <TouchableOpacity style={SHARE_BUTTON} onPress={onShare}>
        <JalaIcon name="share" size={24} color={color.palette.white}/>
      </TouchableOpacity>
    </View>
  )
})

const Region = ({
  data, user, colorScheme, onEdit, onDelete, loading
}:{ data?: any, user?: any, colorScheme?: "light" | "dark", onEdit?: () => void, onDelete?: () => void, loading?: boolean }) => {
  // const { region: { regency_name, province_name} } = selectedPrice;
  const { region: { regency_name: regencyName, province_name: provinceName }, country } = data;
  const isCreator = data.creator && data.creator.id === user.id;

  const region1 = (regencyName && provinceName) || (country || {}).name || '-';
  const region2 = regencyName || provinceName || '-';
  return (
    <View style={SUB_HEADER}>
      <View>
        <Text preset="title3" text={region2} colorScheme={colorScheme} color={color.palette.gray800} />
        <Text preset="title3" text={region1} colorScheme={colorScheme} color={color.palette.gray700} />
      </View>
      {isCreator && (
        <View style={SUB_LEFT}>
          <DeleteModal
            testID="jala:id/delete-button"
            onConfirm={onDelete}
            disabled={loading}
          >
            <Text
              tx="delete"
              preset="title4"
              // color={color.palette.red400}
              colorScheme={colorScheme}
              color={loading ? nativeBaseTheme.colors.muted["500"] : nativeBaseTheme.colors.danger["500"]}
              />
          </DeleteModal>
          {/* <Button testID="jala:id/delete-button" preset="link" textPreset="title4" tx="delete" colorScheme={colorScheme} textColor={color.palette.red700} onPress={onDelete} /> */}
          <Button testID="jala:id/edit-button" preset="link" style={BTN_EDIT} textPreset="title4" tx="edit" colorScheme={colorScheme} onPress={onEdit} />
        </View>
      )}
    </View>
  )
}


const Verified = ({ data, colorScheme }:{ data?: any, colorScheme?: "light" | "dark" }) => {
  // const isPartner = _.isEmpty(data) && data.creator && data.creator.state !== null ? (data.creator.state || {}).partner : false;
  // const isVerified = !!(_.isEmpty(data) && data.creator && data.creator.buyer);
  const isPartner = data && (data.creator || false) && (data.creator.state || false) ? (data.creator.state || {}).partner : false;
  const isVerified = data && (data.creator || false) && data.creator.buyer;
  const mitra = require("./mitra-logo.png");
  const verified = require("./verified.png");

  return (
    <View style={VERFIED_WRAPPER}>
      {isPartner && isVerified && (
        <View style={VERIF_WRAPPER}>
          <AutoImage source={mitra} style={IMG_PARTNER} />
          <Text preset="body3" tx="shrimpPriceDetailScreen.partner" colorScheme={colorScheme} ml="4px" mr="8px" />
        </View>
      )}
      {isVerified ? (
        <>
          <AutoImage source={verified} style={IMG_VERIF} />
          <Text preset="body3" tx="shrimpPriceDetailScreen.verified" colorScheme={colorScheme} style={VERIF_TEXT} />
        </>
      ): (
      <>
        <JalaIcon name="help-outline" color={color.palette.grey} size={18} />
        <Text preset="body3" tx="shrimpPriceDetailScreen.unverified" colorScheme={colorScheme} style={VERIF_TEXT} />
      </>
    )}
    </View>
  )
}

const Profile = ({ data, colorScheme, onPress }:{ data?: any, colorScheme?: "light" | "dark", onPress?: (number) => () => void }) => {
  // const { creator: { name, avatar, phone } } = selectedPrice;
  const { creator } = (data || {});
  const nameText = creator ? creator.name : "-";
  const phoneNum = creator ? creator.phone : "-";
  const url = `${BASE_URL}/img/cache/medium/`;
  const uri = { uri: `${url}${creator ? creator.avatar : '/users/default.png'}` };
  const img = creator && creator.avatar && creator.avatar !== 'users/default.png' ? uri : require('./shrimp-price.png');

  return (
    <View style={PROFILE_WRAPPER}>
      <AutoImage source={img} style={IMG_PROFILE} />
      <View style={DETAIL_WRAPPER}>
        <Text preset="title4" text={nameText} colorScheme={colorScheme} />
        <Text preset="body3" tx="shrimpPriceDetailScreen.contact" color={color.palette.gray600} colorScheme={colorScheme} />
        <View style={CONTACT_WRAPP}>
          <Text preset="title3" text={phoneNum} colorScheme={colorScheme} />
          {creator && creator.phone && <Button
            testID="jala:id/see-contact-button"
            textPreset="title4"
            tx="shrimpPriceDetailScreen.contact"
            onPress={onPress(phoneNum)}
            colorScheme={colorScheme}
            style={CONTACT_BUTTON}
          /> }
        </View>
      </View>
    </View>
  )
}

const Note = ({ data, colorScheme }:{ data?: any, colorScheme?: "light" | "dark" }) => {
  const note = (data || {}).remark || "-";
  return (
    <View style={NOTE_WRAPPER}>
      <Text preset="title3" tx="models.remark" transformText={_.startCase} colorScheme={colorScheme} />
      <Text preset="body2" text={note} colorScheme={colorScheme} />
    </View>
  )
}

const ListPrice = ({ locale, data, size, colorScheme }
  : { locale?: string, data?: any, size?: Array<any>, colorScheme?: "light" | "dark" }
) => {
  const date = data.date ? moment(data.date).locale(locale).format('DD MMMM YYYY') : '-';
  return (
    <View>
      <View style={LIST}>
        <Text preset="title3" tx="shrimpPriceDetailScreen.priceList" colorScheme={colorScheme} />
        <Text preset="body2" text={date} colorScheme={colorScheme} color={color.palette.gray700} />
      </View>
      <View style={HEADER_LIST}>
        <Text preset="title3" tx="shrimpPrices.size" transformText={_.startCase} colorScheme={colorScheme} color={color.palette.gray800} />
        <Text preset="title3" tx="homeScreen.price" colorScheme={colorScheme} color={color.palette.gray800} />
      </View>
      <FlatList
        data={size}
        keyExtractor={(item, index) => String(index)}
        renderItem={({ item }) => <ItemSize data={data} item={item} />}
      />
    </View>
  )
}

const ItemSize = ({ data, item }:{ data?: any, item?: any }) => {
  const { key, price } = item;
  const { currency, currency_id } = data;
  const prices = price && numeral(price).format('0,0.[00]') || "-";
  const colorScheme = "light" || Appearance.getColorScheme();
  const symbol = currency && currency.symbol || currency_id;
  return (
  <View style={PRICE_WRAPPER}>
    <Text preset="body2" text={`${_.upperFirst(translate("shrimpPrices.size"))} ${key}`} colorScheme={colorScheme} color={color.palette.gray800} />
    <Text preset="body2" text={`${symbol} ${prices}`} color={color.palette.gray800} colorScheme={colorScheme} />
  </View>
  )
}

export const CardItem = ({ data, colorScheme, onPress }:{ index?: number, data?: any, colorScheme?: "light" | "dark", onPress?: () => void }) => {
  const {
    creator, currency, date, region,
    size_100, shrimp_price_per_week_region_id, currency_id
  } = (data || {});
  const { diff_max_size_100 } = (shrimp_price_per_week_region_id || {})
  const isVerified = !!(creator && creator.buyer === true);
  const creatorValue = creator && ! _.isEmpty(creator) ? (creator.name || creator.company) : '-';
  const isPartner = creator && (creator.state || {}).partner || false;
  const city = region.name || '-';
  const formatedDate = moment(date).format('dddd, DD MMMM YYYY');
  const img = isPartner ? require("./mitra-logo.png") : require("./verified.png");

  const price = size_100 && (size_100 >= 0.01 || size_100 <= -0.01) ? numeral(size_100).format('0,0.[00]') : '-';
  const diffPrice = !!diff_max_size_100 && (diff_max_size_100 >= 1 || diff_max_size_100 <= -1) ? numeral(diff_max_size_100).format('0,0') : '-';
  const isMinus = diff_max_size_100 ? Math.sign(diff_max_size_100) === -1 : false;
  const icon = isMinus ? 'arrow_drop_down' : 'arrow_drop_up';
  const colour = isMinus ? color.palette.redLight : color.palette.green600;
  const symbol = currency && currency.symbol || currency_id;
  return (
    <Button preset="link" style={CARD_WRAPPER} colorScheme={colorScheme} onPress={onPress}>
      <Text preset="title3" text={city} style={TEXT_REGION} ellipsizeMode="tail" numberOfLines={1} colorScheme={colorScheme} />
      <Text preset="caption2" text={formatedDate} mb="8px" color={color.palette.gray800} colorScheme={colorScheme} />
      <View style={VERIF_WRAPPER}>
        {isVerified ? <AutoImage source={img} style={IMG_PARTNER} /> : <JalaIcon name="help-outline" size={16} color={color.palette.grey} />}
        <Text preset="body3" text={creatorValue} width={180} numberOfLines={1} ellipsizeMode="tail" ml="4px" colorScheme={colorScheme} color={color.palette.gray700} />
      </View>
      <View style={PRICE_DIFF_WRAP}>
        <Text preset="display3" text={`${symbol} ${price}`} color={color.primary} mr="8px" colorScheme={colorScheme} />
        {diffPrice !== "-" && (
          <View style={PRICE_DIFF(isMinus)}>
            <JalaIcon name={icon} color={colour} size={16} />
            <Text preset="body3" text={`${isMinus ? "-" : "+"}${symbol}${diffPrice}`} color={color.palette.gray700} colorScheme={colorScheme} />
          </View>
        )}
      </View>
    </Button>
  )
}

export const ShrimpPriceDetailScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function ShrimpPriceDetailScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), navigation, route } = props

  // Pull in one of our MST stores
  const {
    appStore: { locale },
    userStore: { user },
    shrimpPriceStore,
    shrimpPriceStore: { shrimpPrices, shrimpPrice }
  } = useStores();
  const [ size, setSize ] = useState<Array<any>>([]);
  const [ model, setModel ] = useState<SyncableModel>(null)

  useEffect(() => {
    const price = route?.params?.shrimpPrice || shrimpPrice
    if (price) {
        const model = ShrimpPrice.hydrate({...price});
        setModel(model);

        JalaAnalytic.log('Mobile app: visit detail shrimp prices', price);
    }
  }, [route, shrimpPrice, shrimpPriceStore])

  const data = useMemo<any>(() => {
    return shrimpPrice || route?.params?.shrimpPrice;
  }, [route?.params?.shrimpPrice, shrimpPrice])

  const prices = useMemo<any>(() => {
    const prices = shrimpPrices
    const copy = [...shrimpPrices]
    return (prices.length && copy.sort(() => Math.random() - Math.random()).slice(0, 6) || [shrimpPrice]);
  }, [shrimpPrice, shrimpPrices])

  // const currencies = useMemo<any>(() => {
  //   const { currencies } = (route.params || {})
  //   return currencies;
  // }, [route])

  const scrollRef = useRef<ScrollView>(null);

  const dataSize = useCallback(() => {
    if (data) {
      const {
        size_200, size_190, size_180, size_170, size_160, size_150, size_140, size_130, size_120,
        size_110, size_100, size_90, size_80, size_70, size_60, size_50, size_40, size_30, size_20
       } = data;
  
      const dataSize = [
        { key: '20', price: size_20, line: false },
        { key: '30', price: size_30, line: false },
        { key: '40', price: size_40, line: false },
        { key: '50', price: size_50, line: false },
        { key: '60', price: size_60, line: false },
        { key: '70', price: size_70, line: false },
        { key: '80', price: size_80, line: false },
        { key: '90', price: size_90, line: false },
        { key: '100', price: size_100, line: false },
        { key: '110', price: size_110, line: false },
        { key: '120', price: size_120, line: false },
        { key: '130', price: size_130, line: false },
        { key: '140', price: size_140, line: false },
        { key: '150', price: size_150, line: false },
        { key: '160', price: size_160, line: false },
        { key: '170', price: size_170, line: false },
        { key: '180', price: size_180, line: false },
        { key: '190', price: size_190, line: false },
        { key: '200', price: size_200, line: false }
      ];
  
      setSize(dataSize);
      return dataSize;
    }
    return []
  }, [data])

  const formatString = (text) => {
    if (typeof text === 'string') {
      return text.replace(
        /(\w)(\w*)/g,
        (_, firstChar, rest) => firstChar + rest.toLowerCase()
      );
    }
    return '';
  };

  const dataToShare = useCallback(() => {
    const data = shrimpPrice || route?.params?.shrimpPrice;
    const { region } = data;
    const regionName = region ? formatString(region.name) : '-';
    const date = data.date ? moment(data.date).locale(locale) : '-';
    const title = translate('sharePriceTitle', { date: moment(date).format('DD MMM YYYY'), region: regionName });
    const message = translate('checkLink', { url: `${BASE_URL}/shrimp_prices/${data.id}` });
    const url = `${BASE_URL}/shrimp_prices/${data.id}`;
    const sharedData = { title, message, url };
    navigation.setParams({ sharedData });
  }, [locale, navigation, route?.params?.shrimpPrice, shrimpPrice])

  const callNumber = useCallback((phone) => () => {
    let phoneNumber = phone;
    if (Platform.OS !== 'android') {
      phoneNumber = `telprompt:${phone}`;
    } else {
      phoneNumber = `tel:${phone}`;
    }
    Linking.canOpenURL(phoneNumber)
      .then((supported) => {
        if (supported) return Linking.openURL(phoneNumber)
        return supported;
      }).catch((e) => {
        console.log(e)
      });
  }, [])

  useEffect(() => {
    dataSize();
    dataToShare();
  }, [dataSize, dataToShare])

  const handlePress = (item) => () => {
    shrimpPriceStore.set('shrimpPriceId', item.id)
    scrollRef.current?.scrollTo({
      x: 0,
      y: 0,
      animated: true
    });
  }

  const editPrice = useCallback(() => {
    navigate('Home.Stack', 'Home.Price.Create.Second', data)
  }, [data])

  const deletePrice = useCallback(async() => {
    shrimpPriceStore.delete(model)
    await delay(1)
    navigate('Home.Stack', 'Home.ShrimpPrice.List')
  }, [model, shrimpPriceStore])

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.palette.white : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
      scrollViewRef={scrollRef}
    >
      <Region data={data} colorScheme={colorScheme} user={user} onEdit={editPrice} onDelete={deletePrice} />
      <View style={LINE} />
      <Verified data={data} colorScheme={colorScheme} />
      <Profile data={data} colorScheme={colorScheme} onPress={callNumber} />
      <ListPrice locale={locale} data={data} size={size} colorScheme={colorScheme} />
      <Note data={data} colorScheme={colorScheme} />
      <View style={LINE} />
      <Text preset="title3" tx="shrimpPriceDetailScreen.anotherPrice" colorScheme={colorScheme} my="16px" px="16px" />
      <FlatList
        data={prices}
        keyExtractor={(item, index) => String(index)}
        renderItem={({ item }) => <CardItem colorScheme={colorScheme} data={item} onPress={handlePress(item)} />}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={PADDING}
        ItemSeparatorComponent={() => (<View style={WIDTH} />)}
        fadingEdgeLength={64}
      />
    </Screen>
  )
})
